
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/for-personal-trainers",
      function () {
        return require("private-next-pages/fr/for-personal-trainers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/for-personal-trainers"])
      });
    }
  